import { topicsItems } from '@/mocks/home';

export default function TopicsSection() {
  return (
    <section id="topics" className="py-10 md:py-14 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-8">
          热门话题
        </h2>
        <div className="flex flex-wrap gap-3">
          {topicsItems.map((item) => (
            <a
              key={item.id}
              href="#updates"
              className="group flex items-center gap-2 px-4 py-2.5 bg-background-50 rounded-full border border-background-200/70 hover:border-accent-300 hover:bg-accent-50 transition-all duration-200 cursor-pointer"
            >
              <span className="text-sm font-medium text-foreground-800 group-hover:text-accent-700 transition-colors whitespace-nowrap">
                #{item.name}
              </span>
              <span className="text-xs text-foreground-500 whitespace-nowrap">{item.heat}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}